export const getParam = (key, url) => {
    if (!url) {
        url = window.location.href;
    }
    key = key.replace(/[[\\]]/g, "\\$&");
    const regex = new RegExp(`[?&]${key}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const cleanRelativeUrl = (url: string): string => {
    try {
        const base = "https://test.com";
        const parsed = new URL(url, base);
        let pathname = parsed.pathname.replace(/\/+$/, "");
        if (pathname === "") pathname = "/";

        return pathname;
    } catch (e) {
        return url;
    }
};

export const toAbsoluteUrl = (
    relativePath: string,
    options?: { host?: string; protocol?: string }
): string => {
    const protocol = options?.protocol ?? window.location.protocol;
    const host = options?.host ?? window.location.host;
    const normalizedPath = relativePath.startsWith("/") ? relativePath : `/${relativePath}`;
    return `${protocol}//${host}${normalizedPath}`;
};
